import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "posAb",
  style: {"top":"2px","right":"5px","z-index":"2"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5 whiteColor`)
}, "ヘッダー画像を追加", -1)
const _hoisted_6 = { class: "mc innerEditAppointmentContent" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "ページタイトル", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "ページ説明文", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_21 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_25 = {
  key: 0,
  class: "fs14 whiteColor fw600"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_AppointmentInfoContent = _resolveComponent("AppointmentInfoContent")!
  const _component_AdLimitFree = _resolveComponent("AdLimitFree")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "EditAppointmentModal",
    "content-class": "modalStandard modalContent shadowContent rad10 noscroll"
  }, {
    default: _withCtx(() => [
      (_ctx.saving)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "ofs",
        style: _normalizeStyle({
                height: `${_ctx.contentHeight}px`,
                overscrollBehavior: `contain`,
            })
      }, [
        (_ctx.hasImage())
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "w100 posRe ScheduleHeaderImageContent",
              style: {"display":"block"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addImage && _ctx.addImage(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(_ctx.apc.image_url),
                style: {"width":"100%"}
              }, null, 8, _hoisted_1),
              _createElementVNode("div", _hoisted_2, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                  width: "48",
                  height: "48",
                  class: "pointer rad10",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteImage && _ctx.deleteImage(...args)))
                }, null, 8, _hoisted_3), [
                  [_directive_tooltip, `画像を削除`]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("label", {
              key: 1,
              class: _normalizeClass(`ImageIconContent centered pointer posRe w100 blackBg`),
              style: _normalizeStyle({
                    opacity: 0.8,
                    display: `block`,
                    height: `120px`,
                    lineHeight: `120px`,
                }),
              for: "uploadText",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addImage && _ctx.addImage(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/camera_wt.png`),
                class: "mr10",
                width: "33",
                height: "32",
                style: {"margin-top":"-7px"}
              }, null, 8, _hoisted_4),
              _hoisted_5,
              _createElementVNode("input", {
                type: "file",
                class: "drop__input",
                style: {"display":"none"},
                id: "uploadText",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
              }, null, 32)
            ], 4)),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.Util.isPresent(_ctx.apc))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createVNode(_component_TextfieldTag, {
                  placeholder: "一次面接",
                  style: {"height":"50px"},
                  class: "fl fs14 roundForm mw100 w100",
                  value: _ctx.apc.title,
                  onInputValue: _ctx.inputApcTitle
                }, null, 8, ["value", "onInputValue"]),
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_TextareaTag, {
                  placeholder: "タイトル下の説明文を追加",
                  class: "fl fs14 roundForm mw100 w100",
                  style: {"height":"280px"},
                  value: _ctx.apc.content,
                  onInputValue: _ctx.inputApcContent
                }, null, 8, ["value", "onInputValue"]),
                _hoisted_13,
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          _hoisted_15,
          false
            ? (_openBlock(), _createBlock(_component_AppointmentInfoContent, {
                key: 1,
                appoStatus: _ctx.appoStatus,
                appo: _ctx.appo,
                onUpdateAppo: _ctx.updateAppoFromChild,
                locations: _ctx.locations,
                titles: _ctx.titles,
                from: `schedule_view`
              }, null, 8, ["appoStatus", "appo", "onUpdateAppo", "locations", "titles"]))
            : _createCommentVNode("", true),
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _hoisted_19
        ])
      ], 4),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
          }, _hoisted_23)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveInfo && _ctx.saveInfo(...args)))
          }, [
            (_ctx.appoStatus)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.buttonName()), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_26,
      _hoisted_27,
      _createVNode(_component_AdLimitFree, {
        showAds: _ctx.showAds,
        addFrom: `アポ情報`,
        onFadeOutAdModal: _ctx.fadeOutAdModal
      }, null, 8, ["showAds", "onFadeOutAdModal"])
    ]),
    _: 1
  }))
}